(function () {
  function e(value) {
    return String(value || "").replace(/[&<>"']/g, function (m) {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#039;"
      }[m];
    });
  }

  function status(value) {
    if (value === "good") return "Good";
    if (value === "opportunity") return "Opportunity";
    if (value === "missing") return "Missing";
    return "Not assessed";
  }

  function emailAssessment(result) {
    result.type = "opportunity_assessment"; 
    fetch("https://tools.timeoutstudios.ca/api/send-report.php",{
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(result)
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        console.log("Opportunity Assessment email:", data);
      })
      .catch(function (error) {
        console.warn("Opportunity Assessment email failed:", error);
      });
  }

  function collectionTable(collection) {
    if (!collection || !collection.items || !collection.items.length) return "";

    return `
      <h2>${e(collection.title)}</h2>
      <table>
        <thead>
          <tr>
            <th>Assessment Item</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          ${collection.items.map(function (item) {
            return `
              <tr>
                <td>${e(item.label)}</td>
                <td>${e(status(item.value))}</td>
              </tr>
            `;
          }).join("")}
        </tbody>
      </table>
    `;
  }

  function photoSection(photoData) {
    if (!photoData || !photoData.length) {
      return "<p>No photos attached.</p>";
    }

    return `
      <div class="photos">
        ${photoData.map(function (photo, index) {
          return `
            <figure class="photo">
              <img src="${photo.src}" alt="${e(photo.name)}">
              <figcaption>
                <strong>Photo ${index + 1}</strong><br>
                ${e(photo.caption || photo.name || "")}

                ${photo.observation ? `<br><br><strong>Observation:</strong><br>${e(photo.observation)}` : ""}

                ${photo.recommendation ? `<br><br><strong>Recommendation:</strong><br>${e(photo.recommendation)}` : ""}
              </figcaption>
            </figure>
          `;
        }).join("")}
      </div>
    `;
  }

  function listCollections(result) {
    if (!result.recommendedCollections || !result.recommendedCollections.length) {
      return "<li>No significant opportunities identified.</li>";
    }

    return result.recommendedCollections.map(function (collection) {
      return `<li>${e(collection.title)}</li>`;
    }).join("");
  }

  function listProducts(result) {
    if (!result.recommendedProducts || !result.recommendedProducts.length) {
      return "<li>No recommendations generated.</li>";
    }

    return result.recommendedProducts.map(function (product) {
      return `<li>${e(product.product)} <em>(${e(product.collection)})</em></li>`;
    }).join("");
  }

  function create(result) {
    const f = result.fields || {};
    const level = result.level || {};
    const logo = "https://timeoutstudios.ca/cdn/shop/files/new25-black.png";

    const html = `
<!doctype html>
<html>
<head>
<meta charset="utf-8">
<title>Timeout Studios Opportunity Assessment</title>

<style>
  body {
    font-family: Arial, sans-serif;
    margin: 30px;
    padding: 30px;
    color: #111;
    line-height: 1.3;
    max-width: 1240px;
    display: block;
    margin-left: auto;
    margin-right: auto;
    border: 1px solid #333;
    background: #fff;
  }

  .cover {
    position: relative;
    min-height: 230px;
    border-bottom: 3px solid #111;
    padding: 0 0 24px;
    margin-bottom: 24px;
  }

  .logo {
    position: absolute;
    top: 0;
    right: 5%;
    width: 30%;
    max-width: 230px;
    max-height: 90px;
    object-fit: contain;
  }

  .cover-title {
    padding-top: 20px;
    max-width: 60%;
  }

  h1 {
    margin: 0;
    font-size: 34px;
    line-height: 1.1;
  }

  .subtitle {
    margin-top: 8px;
    margin-bottom: 20px;
    font-size: 16px;
    color: #555;
  }

  h2 {
    background: #fafafa;
    border: 1px solid #ddd;
    padding: 10px;
    margin-top: 28px;
    font-size: 20px;
  }

  .meta {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px 18px;
    margin-top: 24px;
  }

  .summary {
    border: 1px solid #ddd;
    padding: 14px;
    white-space: pre-wrap;
  }

  .score {
    display: inline-block;
    padding: 10px 16px;
    border: 1px solid #111;
    font-weight: bold;
    margin-top: 18px;
  }

  .stars {
    font-size: 30px;
    color: #fae002;
    -webkit-text-stroke: 0.5px #666;
    line-height: 1;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 18px;
  }

  th,
  td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
    vertical-align: top;
  }

  th {
    background: #fafafa;
  }

  .photos {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 18px;
  }

  .photo {
    break-inside: avoid;
    margin: 0;
  }

  .photo img {
    width: 100%;
    max-height: 420px;
    object-fit: contain;
    border: 1px solid #ddd;
  }

  .photo figcaption {
    margin-top: 6px;
    font-size: 13px;
  }

  .print {
    margin-bottom: 20px;
    display: block;
    margin-left: auto;
    margin-right: auto;
    padding: 10px 16px;
    background: #111;
    color: #fff;
    border: none;
    cursor: pointer;
  }

  @media print {
    .print {
      display: none;
    }

    body {
      margin: 10mm;
      padding: 0;
      border: 0;
    }

    .cover {
      break-after: avoid;
    }

    h2,
    table,
    figure {
      break-inside: avoid;
    }
  }
</style>
</head>

<body>

<button class="print" onclick="window.print()">Save as PDF / Print</button>

<div class="cover">
  ${logo ? `<img class="logo" src="${logo}" alt="Timeout Studios">` : ""}

  <div class="cover-title">
    <h1>Opportunity Assessment</h1>
    <div class="subtitle">Prepared by Timeout Studios<br>www.timeoutstudios.ca</div>

    <div class="score">
      <div class="stars">${e(level.stars)}</div><br>
      ${e(level.label)}<br>
      Potential Investment: ${e(level.range)}
    </div>
  </div>

  <div class="meta">
    <div><strong>Client:</strong> ${e(f.client)}</div>
    <div><strong>Contact:</strong> ${e(f.contact)}</div>
    <div><strong>Contact Email:</strong> ${e(f.contactEmail)}</div>
    <div><strong>Contact Phone:</strong> ${e(f.contactPhone)}</div>
    <div><strong>Location:</strong> ${e(f.location)}</div>
    <div><strong>Sales Rep:</strong> ${e(f.rep)}</div>
    <div><strong>Date:</strong> ${e(f.date)}</div>
    <div><strong>Industry:</strong> ${e(f.industryLabel)}</div>
  </div>
</div>

<h2>Executive Summary</h2>
<div class="summary">${e(result.executiveSummary)}</div>

<h2>Recommended Collections</h2>
<ul>
  ${listCollections(result)}
</ul>

<h2>Recommended Products</h2>
<ul>
  ${listProducts(result)}
</ul>

${(result.collectionScores || []).map(collectionTable).join("")}

<h2>Assessment Goals</h2>
<div class="summary">${e(f.goals || "")}</div>

<h2>Site Notes</h2>
<div class="summary">${e(f.notes || "")}</div>

<h2>Photos</h2>
${photoSection(result.photoData || [])}

</body>
</html>
`;

    const w = window.open("", "_blank");

    if (!w) {
      alert("Please allow pop-ups to generate the PDF.");
      return;
    }

    w.document.open();
    w.document.write(html);
    w.document.close();
    w.focus();

    setTimeout(function () {
      emailAssessment(result);
    }, 750);
  }

  window.TimeoutOpportunityPDF = {
    create: create
  };
})();